<div class="container-fluid custom-container" *ngIf="user">
  <!-- <h1 class="title">{{ 'user_profile.page_title' | translate }}</h1> -->

  <mat-card appearance="outlined" class="user-profile_card users">
    <mat-card-header>
      <mat-card-title>
        {{ 'user_profile.user_data.title' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="user-profile_fields-grid">
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'user_profile.user_data.label_name' | translate }}
          </mat-label>
          <input type="text" [ngModel]="user.name" matInput readonly />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'user_profile.user_data.label_surname' | translate }}
          </mat-label>
          <input type="text" [ngModel]="user.surname" matInput readonly />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'user_profile.user_data.label_username' | translate }}
          </mat-label>
          <input type="text" [ngModel]="user.username" matInput readonly />
        </mat-form-field>
        <!-- // TODO qui non viene mostrata la mail perchè non c'è nelle info dell'utente-->
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'user_profile.user_data.label_email' | translate }}
          </mat-label>
          <input type="text" [ngModel]="user.email" matInput readonly />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="user-profile_card groups">
    <mat-card-header>
      <mat-card-title>
        {{ 'user_profile.label_groups' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="userGroupSource" class="w-100">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'user_profile.label_name' | translate }}
          </th>
          <td mat-cell *matCellDef="let group">{{ group.name }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator #groupPaginator showFirstLastButtons [length]="user.groups.length" [pageSize]="pageSize"
        [hidePageSize]="true" aria-label="Select page of group elements">
      </mat-paginator>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="user-profile_card permissions">
    <mat-card-header>
      <mat-card-title>
        {{ 'user_profile.label_permissions' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="userPermissionSource" class="w-100">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'user_profile.label_name' | translate }}
          </th>
          <td mat-cell *matCellDef="let permession">{{ permession.name }}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'user_profile.label_description' | translate }}
          </th>
          <td mat-cell *matCellDef="let permession">
            {{ permession.description }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedPermessionColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedPermessionColumns"></tr>
      </table>
      <!--Bottom Pagination-->
      <mat-paginator #permissionPaginator showFirstLastButtons [length]="user.permissions.length" [pageSize]="pageSize"
        [hidePageSize]="true" aria-label="Select page of permession elements">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
